import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../services/data.services"; 


const initialState = {
    loading: true,
    error: '',
    success: '',
    List:[],
    SupportsLits:[]
}
export const SupportList = createAsyncThunk('SupportList', async (searchParams) => {
    let res = await dataService.GetAPI(`admin-users/list-ticket/?${(searchParams.toString())}`);
    return res
})
const SupportListSlice = createSlice({

    name: 'admin-user',
    initialState,
    reducers: {
        HandleSuppportList: (state, action) => {
            state.SupportsLits = action.payload
        },
    },
    extraReducers: {
        // register user
        [SupportList.pending]: (state) => {
            state.loading = true
            state.error = ''
        },
        [SupportList.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data?.success_status){
                state.List=action?.payload?.data;
                state.loading = false

            }else{
                state.error=action?.payload?.data?.message
                state.loading = false

            }
        },
        [SupportList.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { HandleSuppportList } = SupportListSlice.actions;
export default SupportListSlice.reducer